import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import convertDataAttributes from '@widgets/shared/convertDataAttributes';
import { useMemo } from 'preact/compat';
import { defaultConfigs } from '@widgets/ChangePasswordForm/types/config';
import { useCallback, useEffect, useRef, useState, } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import { changePasswordFormSchema } from '@widgets/ChangePasswordForm/validation/schema';
import API from '@widgets/shared/API/connection';
import TextInput from '@widgets/shared/components/form-controls/TextInput';
import FormNotices from '@widgets/shared/components/FormNotices';
function Form(props) {
    const formRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState(undefined);
    const [isRequesting, setIsRequesting] = useState(false);
    const { successUrl, headingSize, title, buttonText, } = props;
    const form = useForm({
        mode: 'onChange',
        resolver: yupResolver(changePasswordFormSchema),
        defaultValues: {
            password: '',
            newPassword: '',
            confirmPassword: '',
        },
    });
    const { getValues, handleSubmit, setError, formState: { isValid, errors }, watch, trigger, } = form;
    const handleNoticeClose = useCallback(() => {
        setErrorMessage(undefined);
    }, []);
    const newPasswordField = watch('newPassword');
    const confirmPasswordField = watch('confirmPassword');
    useEffect(() => {
        if (newPasswordField) {
            trigger('newPassword')
                .then(() => { });
        }
        if (confirmPasswordField) {
            trigger('confirmPassword')
                .then(() => { });
        }
    }, [newPasswordField, confirmPasswordField, trigger]);
    const handleSubmitEvent = () => {
        setIsRequesting(true);
        const values = getValues();
        const formEl = formRef.current;
        API.changePassword(values).then((res) => {
            if (res.success) {
                window.location.href = res.successUrl ?? successUrl ?? '';
            }
            else {
                res.errors.forEach((error) => {
                    if (error.field) {
                        setError(error.field, { message: error.message }, {
                            shouldFocus: true,
                        });
                    }
                });
                if (res.message) {
                    setErrorMessage(res.message);
                }
            }
        })
            .finally(() => {
            setIsRequesting(false);
        });
    };
    return (_jsx(FormProvider, { ...form, children: _jsxs("form", { ref: formRef, onSubmit: handleSubmit(handleSubmitEvent), noValidate: true, className: "form form--login", children: [errorMessage && (_jsx("div", { style: { marginBottom: '1rem' }, children: _jsx(FormNotices, { message: errorMessage, type: "error", handleClose: handleNoticeClose }) })), _jsx("div", { className: "form__content", children: _jsx("h2", { className: headingSize, children: title }) }), _jsx(TextInput, { inputAttrs: {
                        id: 'password',
                        name: 'password',
                        type: 'password',
                    }, labelAttrs: {
                        htmlFor: 'password',
                        text: 'Current Password',
                        isFieldRequired: true,
                    } }), _jsx(TextInput, { inputAttrs: {
                        id: 'new-password',
                        name: 'newPassword',
                        type: 'password',
                    }, labelAttrs: {
                        htmlFor: 'new-password',
                        text: 'New Password',
                        isFieldRequired: true,
                    } }), _jsx(TextInput, { inputAttrs: {
                        id: 'confirm-password',
                        name: 'confirmPassword',
                        type: 'password',
                    }, labelAttrs: {
                        htmlFor: 'confirm-password',
                        text: 'Repeat New Password',
                        isFieldRequired: true,
                    } }), _jsx("div", { className: "form__actions", children: _jsx("button", { type: "submit", className: "btn", disabled: !isValid || isRequesting, children: buttonText ?? 'Change Password' }) })] }) }));
}
function ChangePasswordForm(props) {
    const { dataset } = props;
    const formattedAttributes = convertDataAttributes(dataset ?? {});
    const formConfig = useMemo(() => ({
        ...defaultConfigs,
        ...formattedAttributes,
    }), [formattedAttributes]);
    return (_jsx(Form, { ...formConfig }));
}
export default ChangePasswordForm;
